import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCheck, faPencilAlt } from '@fortawesome/pro-solid-svg-icons';

import { LeadPropTypes } from 'components/project/prop_types';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import Dropdown from 'components/dropdown';
import AccessOptions from '../../project/components/leads/access_options';

import {
  approveLeadVaultAccess,
  revokeLeadVaultAccess,
  blockLeadVaultAccess,
  unblockLeadVaultAccess
} from 'bundles/project/actions/index';
import { refreshLead } from 'bundles/project/actions/leads';
import { showNewTaskModal, showUpdateLeadModal, showLogTaskModal } from './store/actions/ui';

const MENU_ICON_CLASS_NAME = 'mr-2 bo-menu-icon';

export class LeadOptions extends React.Component {
  static propTypes = {
    approveLeadVaultAccess: PropTypes.func.isRequired,
    blockLeadVaultAccess: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
    features: PropTypes.shape({
      projectTasksActivities: PropTypes.bool.isRequired
    }),
    lead: LeadPropTypes,
    refreshLead: PropTypes.func.isRequired,
    revokeLeadVaultAccess: PropTypes.func.isRequired,
    showLogTaskModal: PropTypes.func.isRequired,
    showNewTaskModal: PropTypes.func.isRequired,
    showUpdateLeadModal: PropTypes.func.isRequired,
    unblockLeadVaultAccess: PropTypes.func.isRequired
  };

  render() {
    const { lead, features } = this.props;

    return (
      <Dropdown absolute={true} className="lead-options" id={`leadOptions${lead.id}`}>
        <UnstyledDropdownToggle bsRole="toggle">
          <i className="fas fa-cog fa-lg text-muted clickable settings-icon" />
        </UnstyledDropdownToggle>
        <Dropdown.Menu className="dropdown-menu-right" >
          {features.projectTasksActivities &&
            <React.Fragment>
              <MenuItem
                name="new-task"
                onClick={() => this.props.showNewTaskModal(lead)}
              >
                <FontAwesomeIcon className={MENU_ICON_CLASS_NAME}
                  fixedWidth icon={faCheck} size="sm"
                /> New Task
              </MenuItem>
              <MenuItem
                name="new-activity"
                onClick={() => this.props.showLogTaskModal(lead)}
              >
                <FontAwesomeIcon className={MENU_ICON_CLASS_NAME}
                  fixedWidth icon={faBolt} size="sm"
                /> New Activity
              </MenuItem>
            </React.Fragment>
          }
          <AccessOptions
            approveLeadVaultAccess={this.props.approveLeadVaultAccess}
            blockLeadVaultAccess={this.props.blockLeadVaultAccess}
            currentUser={this.props.currentUser}
            iconClassName={MENU_ICON_CLASS_NAME}
            lead={lead}
            refreshLead={this.props.refreshLead}
            revokeLeadVaultAccess={this.props.revokeLeadVaultAccess}
            unblockLeadVaultAccess={this.props.unblockLeadVaultAccess}
          />
          {(features.projectTasksActivities || lead.propertyVaultProfiles.length > 0) &&
            <MenuItem divider key="divider" />}
          <MenuItem
            name="edit-lead"
            onClick={() => this.props.showUpdateLeadModal(lead)}
          >
            <FontAwesomeIcon className={MENU_ICON_CLASS_NAME} fixedWidth icon={faPencilAlt} size="sm" /> Edit
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.currentUser,
  features: state.features
});

const actions = {
  approveLeadVaultAccess,
  blockLeadVaultAccess,
  showUpdateLeadModal,
  showNewTaskModal,
  showLogTaskModal,
  refreshLead,
  revokeLeadVaultAccess,
  unblockLeadVaultAccess
};

export default connect(mapStateToProps, actions)(LeadOptions);
